import type { MetaAdPublishStatus } from '../../../types/metaAdDraft';
import { RadioGroup } from './RadioGroup';

// Publish Active / Publish Off toggle. One draft value (campaign.publishStatus)
// drives the delivery state of the campaign + every ad set at publish. Rendered in
// TWO places (top of the builder + next to the Publish action) bound to the SAME
// state, so flipping either reflects in both.
export function PublishStatusToggle({
  value,
  onChange,
  label = 'Publish state',
}: {
  value: MetaAdPublishStatus;
  onChange: (value: MetaAdPublishStatus) => void;
  label?: string;
}) {
  return (
    <RadioGroup<MetaAdPublishStatus>
      label={label}
      value={value}
      options={[
        { value: 'ACTIVE', label: 'Publish active', description: 'Goes live immediately' },
        { value: 'PAUSED', label: 'Publish off', description: 'Paused — turn on in Meta later' },
      ]}
      onChange={onChange}
    />
  );
}
